export default __webpack_public_path__ + "4758bf296e14ef338490260d9c8bac5c.png";